import { RGB } from "../types";

export const getColorFromImageData = (
  imageData: ImageData,
  startX: number,
  startY: number,
  width: number,
  height: number
): RGB => {
  let r = 0;
  let g = 0;
  let b = 0;
  let count = 0;

  for (let x = startX; x < startX + width; x += 2) {
    for (let y = startY; y < startY + height; y += 2) {
      const i = (y * imageData.width + x) * 4;
      r += imageData.data[i];
      g += imageData.data[i + 1];
      b += imageData.data[i + 2];
      count += 1;
    }
  }

  return {
    r: Math.round(r / count),
    g: Math.round(g / count),
    b: Math.round(b / count)
  };
};

export const rgbToHex = (r: number, g: number, b: number): string => {
  return `#${[r, g, b]
    .map((x) => {
      const hex = x.toString(16);
      return hex.length === 1 ? `0${hex}` : hex;
    })
    .join("")}`;
};

export const adjustColor = (color: RGB, factor: number): RGB => {
  return {
    r: Math.min(255, Math.round(color.r * factor)),
    g: Math.min(255, Math.round(color.g * factor)),
    b: Math.min(255, Math.round(color.b * factor))
  };
};
